$(document).ready(function () {
    const swiperDetails = new Swiper('.product-details-recommend-slider .swiper', {
        loop: true,
        slidesPerView: 4,       // Show 3 slides per view
        spaceBetween: 30,       // 30px gap between slides
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 1000,                 // 3s between slides
            disableOnInteraction: false, // keep autoplay after swipe
            pauseOnMouseEnter: true,     // pause on hover (desktop)
        },

        speed: 600, // smooth transition
        breakpoints: {
            0: {
                slidesPerView: 1.5
            },
            768: {
                slidesPerView: 2.5
            },
            992: {
                slidesPerView: 3.5
            },
            1200: {
                slidesPerView: 4.5
            },
        }
    });
    $(document).on('click', '.opencontactDetailsPopup', function (e) {
        e.preventDefault()
        var myModal = new bootstrap.Modal(document.getElementById('contactDetailsPopup'));
        myModal.show();
    });
    $(".goBackBtn").on("click", function () { window.history.back() })
});